import React, { useEffect, useState } from "react";
import { Button, Card, CardContent, TextField } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { client } from "src/common/axiosClient";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Breadcrumb, PageContainer } from "../common";
import Loading from "../common/Loading";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Checkbox,
} from "@mui/material";

const localizer = momentLocalizer(moment);

function MaunalTheraistPaidLeave() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [doctorData, setDoctorData] = useState<any>({});
  const [metaData, setMetaData] = useState<any>({});
  const [dayOff, setDayOff] = useState<any[]>([]); // Initialize as an empty array
  const [isLoading, setIsLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [checked, setChecked] = useState({
    full: false,
    morning: false,
    afternoon: false,
    night: false,
  });
  const [memo, setMemo] = useState("");

  // 현재 월의 날짜들을 얻기 위한 함수
  const getDatesInMonth = (year: any, month: any) => {
    const startDate = moment([year, month]);
    const endDate = startDate.clone().endOf("month");
    const dates = [];

    while (startDate.isBefore(endDate) || startDate.isSame(endDate, "day")) {
      dates.push(startDate.clone());
      startDate.add(1, "days");
    }

    return dates;
  };

  // 현재 월의 휴진 이벤트 생성
  const generateEvents = (date: any) => {
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();
    const datesInMonth = getDatesInMonth(currentYear, currentMonth);

    const newEvents: any = [];

    datesInMonth.forEach((date) => {
      const dayOfWeek = date.format("dddd").toLowerCase(); // 예: 'monday'

      if (metaData[dayOfWeek]) {
        const periods = ["full", "morning", "afternoon", "night"];

        periods.forEach((period) => {
          if (metaData[dayOfWeek][period] === null) {
            let title = "";
            switch (period) {
              case "morning":
                title = "오전 휴진";
                break;
              case "afternoon":
                title = "오후 휴진";
                break;
              case "night":
                title = "야간 휴진";
                break;
            }
            newEvents.push({
              title: `${date.format("YYYY-MM-DD")} ${title}`,
              start: date.clone().toDate(),
              end: date.clone().toDate(),
              allDay: true,
              style: { backgroundColor: "lightcoral", color: "white" }, // 휴진 스타일
            });
          }
        });
      }

      // Check for dayOff entries
      const dayOffEntries = dayOff.filter(
        (entry: any) => entry.date === date.format("YYYY-MM-DD")
      );
      dayOffEntries.forEach((entry: any) => {
        let title = "";
        switch (entry.type.toLowerCase()) {
          case "full":
            title = "종일 연차";
            break;
          case "morning":
            title = "오전 연차";
            break;
          case "afternoon":
            title = "오후 연차";
            break;
          case "night":
            title = "야간 연차";
            break;
        }
        newEvents.push({
          title: `${date.format("YYYY-MM-DD")} ${title}`,
          start: date.clone().toDate(),
          end: date.clone().toDate(),
          allDay: true,
          style: { backgroundColor: "lightblue", color: "white" }, // 연차 스타일
        });
      });
    });

    setEvents(newEvents);
  };

  const eventStyleGetter = (event: any) => {
    return {
      style: {
        backgroundColor: event.style.backgroundColor,
        color: event.style.color,
      },
    };
  };

  useEffect(() => {
    getDoctorInfo();
  }, []);
  useEffect(() => {
    generateEvents(currentDate); // 초기 이벤트 생성
  }, [metaData, dayOff]);

  const getDoctorInfo = async () => {
    setDoctorData({});
    const response = await client.get(
      `admin/api/v1/medical-staff/MANUAL_THERAPIST/${id}`
    );
    if (response.status === 200) {
      console.log(response);
      if (response.data.content) {
        setDoctorData(response.data.content);
        getDoctorMeta();
      }
    } else {
      console.log(response);
    }
  };

  const getDoctorMeta = async () => {
    try {
      setMetaData({});
      const response = await client.get(
        `admin/api/v1/schedule-meta/MANUAL_THERAPIST/${id}`
      );
      if (response.status === 200) {
        console.log(response);
        setMetaData(response.data.content ? response.data.content : {});
        getDoctorDayOff();
      } else {
        console.error(
          "Failed to fetch doctor meta data with status: ",
          response.status
        );
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching doctor meta data: ",
        error
      );
    }
  };

  const getDoctorDayOff = async () => {
    try {
      const response = await client.get(
        `admin/api/v1/schedule-day-off/MANUAL_THERAPIST/${id}`
      );
      if (response.status === 200) {
        console.log(response);
        setDayOff(response.data.content ? response.data.content : []);
      } else {
        console.error(
          "Failed to fetch doctor day off data with status: ",
          response.status
        );
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching doctor day off data: ",
        error
      );
    }
  };

  const handleNavigate = (date: any) => {
    setCurrentDate(date);
    generateEvents(date);
  };

  const handleSelectSlot = (slotInfo: any) => {
    setSelectedDate(moment(slotInfo.start));
    setOpen(true);
  };

  const handleClose = () => {
    setChecked({
      full: false,
      morning: false,
      afternoon: false,
      night: false,
    });
    setMemo("");
    setOpen(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked({
      ...checked,
      [event.target.name]: event.target.checked,
    });
  };

  const handleMemoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMemo(event.target.value);
  };

  const handleDayOffCancel = async (offId: any) => {
    try {
      await client.delete(
        `admin/api/v1/schedule-day-off/MANUAL_THERAPIST/${id}/${offId}`
      );
      getDoctorDayOff(); // Refresh day off data
    } catch (error) {
      console.error("An error occurred while canceling day off: ", error);
    }
  };

  const handleSave = async () => {
    const dayOffData = [];
    if (
      checked.full &&
      !dayOff.some(
        (entry) =>
          entry.date === selectedDate.format("YYYY-MM-DD") &&
          entry.type === "FULL"
      )
    ) {
      dayOffData.push({
        date: selectedDate.format("YYYY-MM-DD"),
        type: "FULL",
        reason: memo,
      });
    }
    if (
      checked.morning &&
      !dayOff.some(
        (entry) =>
          entry.date === selectedDate.format("YYYY-MM-DD") &&
          entry.type === "MORNING"
      )
    ) {
      dayOffData.push({
        date: selectedDate.format("YYYY-MM-DD"),
        type: "MORNING",
        reason: memo,
      });
    }
    if (
      checked.afternoon &&
      !dayOff.some(
        (entry) =>
          entry.date === selectedDate.format("YYYY-MM-DD") &&
          entry.type === "AFTERNOON"
      )
    ) {
      dayOffData.push({
        date: selectedDate.format("YYYY-MM-DD"),
        type: "AFTERNOON",
        reason: memo,
      });
    }
    if (
      checked.night &&
      !dayOff.some(
        (entry) =>
          entry.date === selectedDate.format("YYYY-MM-DD") &&
          entry.type === "NIGHT"
      )
    ) {
      dayOffData.push({
        date: selectedDate.format("YYYY-MM-DD"),
        type: "NIGHT",
        reason: memo,
      });
    }

    try {
      for (const data of dayOffData) {
        const response = await client.post(
          `admin/api/v1/schedule-day-off/MANUAL_THERAPIST/${id}`,
          data
        );
        if (
          response.data.meta.result === "FAIL" &&
          response.data.meta.errorCode === "SCHEDULE_DAY_OFF_RESERVATION_EXISTS"
        ) {
          alert(response.data.meta.errorMessage);
          return;
        }
      }
      alert("연차 신청이 완료되었습니다.");
      getDoctorDayOff(); // Refresh day off data
      handleClose();
    } catch (error) {
      console.error("An error occurred while saving day off data: ", error);
    }
  };

  const hasExistingDayOff = (type: string) => {
    return dayOff.some(
      (entry: any) =>
        entry.date === selectedDate?.format("YYYY-MM-DD") &&
        entry.type.toLowerCase() === type.toLowerCase()
    );
  };

  const hasAnyChecked = () => {
    return (
      checked.full || checked.morning || checked.afternoon || checked.night
    );
  };

  const hasAnyExistingDayOff = () => {
    return (
      hasExistingDayOff("full") ||
      hasExistingDayOff("morning") ||
      hasExistingDayOff("afternoon") ||
      hasExistingDayOff("night")
    );
  };

  return (
    <PageContainer>
      <Loading isLoading={isLoading} />
      <form>
        <Breadcrumb
          action={
            <div>
              <Button
                size="medium"
                variant="outlined"
                sx={{ marginRight: "8px" }}
                onClick={() => navigate(-1)}
              >
                목록으로
              </Button>
              <Button
                variant="contained"
                size="medium"
                disabled={!hasAnyChecked()}
              >
                저장
              </Button>
            </div>
          }
        >
          <div className="flex items-center">
            <div className="w-32 mr-5">
              <img src={doctorData.profileImageUrl} alt="Doctor" />
            </div>
            {doctorData?.name} 기본 스케줄 설정페이지
          </div>
        </Breadcrumb>
        <Card>
          <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>휴진 설정</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {selectedDate && selectedDate.format("YYYY-MM-DD")}의 휴진
                설정을 변경합니다.
              </DialogContentText>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">휴진 시간대</FormLabel>
                <FormGroup>
                  {dayOff.filter(
                    (entry: any) =>
                      entry.date === selectedDate?.format("YYYY-MM-DD") &&
                      entry.type.toLowerCase() === "full"
                  ).length > 0 ? (
                    <Button
                      variant="contained"
                      onClick={() =>
                        handleDayOffCancel(
                          dayOff.find(
                            (entry: any) =>
                              entry.date ===
                                selectedDate?.format("YYYY-MM-DD") &&
                              entry.type.toLowerCase() === "full"
                          ).id
                        )
                      }
                    >
                      연차 취소
                    </Button>
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked.full}
                          onChange={handleChange}
                          name="full"
                          disabled={
                            metaData[selectedDate?.format("dddd").toLowerCase()]
                              ?.full === null ||
                            hasAnyExistingDayOff() ||
                            (hasAnyChecked() && !checked.full)
                          }
                        />
                      }
                      label="종일 연차"
                    />
                  )}
                  {dayOff.filter(
                    (entry: any) =>
                      entry.date === selectedDate?.format("YYYY-MM-DD") &&
                      entry.type.toLowerCase() === "morning"
                  ).length > 0 ? (
                    <Button
                      variant="contained"
                      onClick={() =>
                        handleDayOffCancel(
                          dayOff.find(
                            (entry: any) =>
                              entry.date ===
                                selectedDate?.format("YYYY-MM-DD") &&
                              entry.type.toLowerCase() === "morning"
                          ).id
                        )
                      }
                    >
                      오전 반차 취소
                    </Button>
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked.morning}
                          onChange={handleChange}
                          name="morning"
                          disabled={
                            metaData[selectedDate?.format("dddd").toLowerCase()]
                              ?.morning === null ||
                            hasAnyExistingDayOff() ||
                            (hasAnyChecked() && !checked.morning)
                          }
                        />
                      }
                      label="오전 반차"
                    />
                  )}
                  {dayOff.filter(
                    (entry: any) =>
                      entry.date === selectedDate?.format("YYYY-MM-DD") &&
                      entry.type.toLowerCase() === "afternoon"
                  ).length > 0 ? (
                    <Button
                      variant="contained"
                      onClick={() =>
                        handleDayOffCancel(
                          dayOff.find(
                            (entry: any) =>
                              entry.date ===
                                selectedDate?.format("YYYY-MM-DD") &&
                              entry.type.toLowerCase() === "afternoon"
                          ).id
                        )
                      }
                    >
                      오후 반차 취소
                    </Button>
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked.afternoon}
                          onChange={handleChange}
                          name="afternoon"
                          disabled={
                            metaData[selectedDate?.format("dddd").toLowerCase()]
                              ?.afternoon === null ||
                            hasAnyExistingDayOff() ||
                            (hasAnyChecked() && !checked.afternoon)
                          }
                        />
                      }
                      label="오후 반차"
                    />
                  )}
                  {dayOff.filter(
                    (entry: any) =>
                      entry.date === selectedDate?.format("YYYY-MM-DD") &&
                      entry.type.toLowerCase() === "night"
                  ).length > 0 ? (
                    <Button
                      variant="contained"
                      onClick={() =>
                        handleDayOffCancel(
                          dayOff.find(
                            (entry: any) =>
                              entry.date ===
                                selectedDate?.format("YYYY-MM-DD") &&
                              entry.type.toLowerCase() === "night"
                          ).id
                        )
                      }
                    >
                      야간 반차 취소
                    </Button>
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked.night}
                          onChange={handleChange}
                          name="night"
                          disabled={
                            metaData[selectedDate?.format("dddd").toLowerCase()]
                              ?.night === null ||
                            hasAnyExistingDayOff() ||
                            (hasAnyChecked() && !checked.night)
                          }
                        />
                      }
                      label="야간반차"
                    />
                  )}
                </FormGroup>
                <TextField
                  label="메모"
                  multiline
                  rows={4}
                  value={memo}
                  onChange={handleMemoChange}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                />
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                취소
              </Button>
              <Button onClick={handleSave} color="primary">
                저장
              </Button>
            </DialogActions>
          </Dialog>

          <CardContent>
            <Calendar
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 800 }}
              eventPropGetter={eventStyleGetter} // 이벤트 스타일 커스터마이징
              onNavigate={handleNavigate} // 월이 변경될 때 호출되는 콜백
              selectable
              onSelectSlot={handleSelectSlot} // 날짜 클릭 시 호출되는 콜백
            />
          </CardContent>
        </Card>
      </form>
    </PageContainer>
  );
}

export default MaunalTheraistPaidLeave;
